import { z } from "zod";

/** An artist as the catalog serves it: its id, name and image. */
export const artistSchema = z.object({
  id: z.string(),
  name: z.string(),
  image: z.string().nullable(),
});

export type Artist = z.infer<typeof artistSchema>;

/** An artist as a search result. */
export const searchArtistSchema = artistSchema.extend({
  type: z.literal("artist"),
});

export type SearchArtist = z.infer<typeof searchArtistSchema>;
